import Location from '@/models/location';

/**
 * Second line under the place name in Add-place list rows (city / area / country).
 */
export function getPlaceSearchResultSubtitle(location: Location): string {
    const cid = location.city_identifying_name?.trim();
    if (cid) return cid;

    const a3 = location.a3_intl_address?.trim();
    if (a3) return a3;

    const addr = location.address?.trim() || '';
    if (addr) {
        const parts = addr.split(',').map((s) => s.trim()).filter(Boolean);
        if (parts.length >= 2) return parts.slice(1).join(', ');
        return addr;
    }

    const country = typeof location.country === 'string' ? location.country.trim() : '';
    if (country) return country;

    return 'Location details unavailable';
}
